import { render, staticRenderFns } from "./CompleteProfileThanks.vue?vue&type=template&id=973fa288"
import script from "./CompleteProfileThanks.vue?vue&type=script&lang=js"
export * from "./CompleteProfileThanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports